module.exports = __webpack_public_path__ + "static/media/undraw_authentication_fsn5.5911f723.svg";